import requset from "utils/request";
import baseURL from '@/api/env.js'
// 推广精彩内容
export function extensionDetail(msg, action) {
  return requset({
    url: `${baseURL.AHEAD}/book/log/request?msg=${msg}&action=${action}`,
    headers:{"lang":"zh_TW", "client-platform":2},
    method: "GET",
    msg: 0,
  });
}
// 推广公共
export function adminNoticecontent(params) {
  return requset({
    url: `${baseURL.AHEAD}/book/cdn/adminNotice/content`,
    method: "GET",
    params
  });
}
